import React, { Fragment, useRef, useState } from "react";
import ColorPicker from "material-ui-color-picker";
import Loader from "../../common/Loader"
import { FONT_FAMILY, ICON, CLASSNAME_P_B, CLASSNAME_P_R, CLASSNAME_P_L, CLASSNAME_P_T, CLASSNAME_M_R, CLASSNAME_M_L, CLASSNAME_M_B, CLASSNAME_M_T } from '../../constant/bannerItems'
import DeleteIcon from '@material-ui/icons/Delete';
import { List, makeStyles, ListItem, ListItemText, ListItemSecondaryAction, TextField, Button, FormControl, Select, MenuItem, FormControlLabel, Checkbox,Switch } from "@material-ui/core";
import JoditEditor from "jodit-react";
import TextEditorConfig from "../../helpers/TextEditor";

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		maxWidth: 600,
		backgroundColor: theme.palette.background.paper,
	},
	createUser: {
		width: '100%',
		maxWidth: 800,
	},
	textField: {
		width: '40ch',
	}
}));

const CategorySectionForm = ({ catId, isLoading, handleCheckboxInputChange, handleInputChangeUrl, handleClose, inputs, handleInputChange, resetColor, handleColorPicker, handleSubmit, errors, deleteImage, editType, setImageFile, setToggle, toggle }) => {

	const classes = useStyles();
	const editor = useRef(null)
	const [temp, setTemp] = useState("")

	const errorClass = {
		color: "red",
	}

	const onSubmit = () => {
		handleSubmit()
	}

	const handleInputSwitchChange = (e, key) => {
        if (e.target.checked) {
            inputs[key] = true
        } else {
            inputs[key] = false
        }
        setToggle(!toggle)
    }

	return (
		<Fragment>
			{isLoading && (
				<Loader />
			)}
			<div className="banner-form" style={{ 'minHeight': '50vh' }}>
				<form className="banner-form-style" >
					<List>
						{(editType == "sectionFirst" || editType == "mainSettings") && <><h4><b>Category One</b></h4>
							<hr />
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-firstCatMainText" primary="Main Text" />
									</div>
									<div className="col-md-9 form-group">
										<JoditEditor
											ref={editor}
											value={inputs.firstCatMainText}
											config={TextEditorConfig}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.firstCatMainText = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>

							</ListItem>

							<ListItem className="mb-15">
								<div className="col-lg-3 p-0">
									<ListItemText className="" id="switch-list-label-wifi" primary="Main Text Font Color" />
								</div>
								<div className="col-lg-2">
									<ColorPicker
										name="firstCatMainTextColor"
										defaultValue="#000"
										value={inputs.firstCatMainTextColor}
										onChange={color => { handleColorPicker('firstCatMainTextColor', color) }}
									/>
								</div>
								<div className="col-lg-3 d-flex align-items-center">
									<p className="m-0 pl-70">{inputs.firstCatMainTextColor != undefined && inputs.firstCatMainTextColor != "undefined" && (inputs.firstCatMainTextColor)}</p>
									{inputs.firstCatMainTextColor != "undefined" &&
										inputs.firstCatMainTextColor != undefined &&
										inputs.firstCatMainTextColor != "" && (
											<DeleteIcon
												className="text-error ml-4"
												title={"Reset"}
												onClick={() => {
													resetColor("", 'firstCatMainTextColor')
												}}
												aria-label=""
											/>)}
								</div>
							</ListItem>

							<ListItem className="">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-firstCatMainTextFont" primary="Main Text Font" />
									</div>
									<div className="col-md-9 form-group">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.firstCatMainTextFont == "" ? " " : inputs.firstCatMainTextFont}
												onChange={handleInputChange}
												name="firstCatMainTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-firstCatMainTextFontSize" primary="Main Text Font Size" />
									</div>
									<div className="col-md-9 form-group">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.firstCatMainTextFontSize}
											onChange={handleInputChange}
											name="firstCatMainTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.firstCatMainTextFontSize ? errors.firstCatMainTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>

							<ListItem>
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-firstCatText" primary="Text" />
									</div>
									<div className="col-md-9 form-group">
										<JoditEditor
											ref={editor}
											value={inputs.firstCatText}
											config={TextEditorConfig}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.firstCatText = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Text Font Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="firstCatTextColor"
											defaultValue="#000"
											value={inputs.firstCatTextColor}
											onChange={color => { handleColorPicker('firstCatTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-20">{inputs.firstCatTextColor != undefined && inputs.firstCatTextColor != "undefined" && (inputs.firstCatTextColor)}</p>
										{inputs.firstCatTextColor != "undefined" &&
											inputs.firstCatTextColor != undefined &&
											inputs.firstCatTextColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'firstCatTextColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-firstCatTextFont" primary="Text Font" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.firstCatTextFont == "" ? " " : inputs.firstCatTextFont}
												onChange={handleInputChange}
												name="firstCatTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>

							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-firstCatTextFontSize" primary="Text Font Size" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.firstCatTextFontSize}
											onChange={handleInputChange}
											name="firstCatTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.firstCatTextFontSize ? errors.firstCatTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-firstCatMainText" primary="Sub Text" />
									</div>
									<div className="col-md-9 form-group">
										<JoditEditor
											ref={editor}
											value={inputs.firstCatPriceText}
											config={TextEditorConfig}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.firstCatPriceText = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Sub Text Font Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="firstCatPriceTextColor"
											defaultValue="#000"
											value={inputs.firstCatPriceTextColor}
											onChange={color => { handleColorPicker('firstCatPriceTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.firstCatPriceTextColor != undefined && inputs.firstCatPriceTextColor != "undefined" && (inputs.firstCatPriceTextColor)}</p>
										{inputs.firstCatPriceTextColor != "undefined" &&
											inputs.firstCatPriceTextColor != undefined &&
											inputs.firstCatPriceTextColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'firstCatPriceTextColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-firstCatPriceTextFont" primary="Sub Text Font" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.firstCatPriceTextFont == "" ? " " : inputs.firstCatPriceTextFont}
												onChange={handleInputChange}
												name="firstCatPriceTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-firstCatPriceTextFontSize" primary="Sub Text Font Size" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.firstCatPriceTextFontSize}
											onChange={handleInputChange}
											name="firstCatPriceTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.firstCatPriceTextFontSize ? errors.firstCatPriceTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Image" />
									</div>
									<div className="col-lg-4">
										<input onChange={(e) => setImageFile(e, 'firstCatImage')}
											type="file"
											name="firstCatImage"
											accept="image/*"
										/>
									</div>
									<div className="col-lg-4"> {inputs.firstCatImage != "" && (<>
										<img height="50px" width="50px" src={inputs.firstCatImage}></img>
										<DeleteIcon
											className="text-error"
											title={"Delete"}
											onClick={() => {
												deleteImage("firstCatImage")
											}}
											aria-label=""
										/></>)}
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Category Link" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											label=""
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.firstCatLink}
											onChange={(e) => handleInputChangeUrl(e, "firstCatLink")}
											name="firstCatLink"
											error={errors && errors.firstCatLink ? true : false
											}
											helperText={errors && errors.firstCatLink ? errors.firstCatLink : ""}
										/>
									</div>
								</div>
							</ListItem>
						</>}
						{(editType == "sectionSecond" || editType == "mainSettings") && <><h4><b>Category Two</b></h4>
							<hr />
							{/* <ListItem className="mb-15">
								<ListItemText id="switch-secondCatMainText" primary="Main Text" />
								<TextField
									id="outlined-basic"
									type="text"
									size="medium"
									variant="outlined"
									fullWidth
									className={classes.textField}
									value={inputs.secondCatMainText}
									onChange={handleInputChange}
									name="secondCatMainText"
								/>
							</ListItem> */}

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-secondCatMainText" primary="Main Text" />
									</div>
									<div className="col-md-9 form-group">
										<JoditEditor
											ref={editor}
											value={inputs.secondCatMainText}
											config={TextEditorConfig}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.secondCatMainText = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Main Text Font Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="secondCatMainTextColor"
											defaultValue="#000"
											value={inputs.secondCatMainTextColor}
											onChange={color => { handleColorPicker('secondCatMainTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.secondCatMainTextColor != undefined && inputs.secondCatMainTextColor != "undefined" && (inputs.secondCatMainTextColor)}</p>
										{inputs.secondCatMainTextColor != "undefined" &&
											inputs.secondCatMainTextColor != undefined &&
											inputs.secondCatMainTextColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'secondCatMainTextColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-secondCatMainTextFont" primary="Main Text Font" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.secondCatMainTextFont == "" ? " " : inputs.secondCatMainTextFont}
												onChange={handleInputChange}
												name="secondCatMainTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-secondCatMainTextFontSize" primary="Main Text Font Size" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.secondCatMainTextFontSize}
											onChange={handleInputChange}
											name="secondCatMainTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.secondCatMainTextFontSize ? errors.secondCatMainTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-secondCatText" primary="Text" />
									</div>
									<div className="col-md-9 form-group">
										<JoditEditor
											ref={editor}
											value={inputs.secondCatText}
											config={TextEditorConfig}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.secondCatText = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Text Font Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="secondCatTextColor"
											defaultValue="#000"
											value={inputs.secondCatTextColor}
											onChange={color => { handleColorPicker('secondCatTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.secondCatTextColor != undefined && inputs.secondCatTextColor != "undefined" && (inputs.secondCatTextColor)}</p>
										{inputs.secondCatTextColor != "undefined" &&
											inputs.secondCatTextColor != undefined &&
											inputs.secondCatTextColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'secondCatTextColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-secondCatTextFont" primary="Text Font" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.secondCatTextFont == "" ? " " : inputs.secondCatTextFont}
												onChange={handleInputChange}
												name="secondCatTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">.
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-secondCatTextFontSize" primary="Text Font Size" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.secondCatTextFontSize}
											onChange={handleInputChange}
											name="secondCatTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.secondCatTextFontSize ? errors.secondCatTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-secondCatPriceText" primary="Sub Text" />
									</div>
									<div className="col-md-9 form-group">
										<JoditEditor
											ref={editor}
											value={inputs.secondCatPriceText}
											config={TextEditorConfig}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.secondCatPriceText = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>

							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Sub Text Font Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="secondCatPriceTextColor"
											defaultValue="#000"
											value={inputs.secondCatPriceTextColor}
											onChange={color => { handleColorPicker('secondCatPriceTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.secondCatPriceTextColor != undefined && inputs.secondCatPriceTextColor != "undefined" && (inputs.secondCatPriceTextColor)}</p>
										{inputs.secondCatPriceTextColor != "undefined" &&
											inputs.secondCatPriceTextColor != undefined &&
											inputs.secondCatPriceTextColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'secondCatPriceTextColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-secondCatPriceTextFont" primary="Sub Text Font" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.secondCatPriceTextFont == "" ? " " : inputs.secondCatPriceTextFont}
												onChange={handleInputChange}
												name="secondCatPriceTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-secondCatPriceTextFontSize" primary="Sub Text Font Size" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.secondCatPriceTextFontSize}
											onChange={handleInputChange}
											name="secondCatPriceTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.secondCatPriceTextFontSize ? errors.secondCatPriceTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Image" />
									</div>
									<div className="col-lg-4">
										<input onChange={(e) => setImageFile(e, 'secondCatImage')}
											type="file"
											name="secondCatImage"
											accept="image/*"
										/>
									</div>
									<div className="col-lg-4"> {inputs.secondCatImage != "" && (<>
										<img height="50px" width="50px" src={inputs.secondCatImage}></img>
										<DeleteIcon
											className="text-error"
											title={"Delete"}
											onClick={() => {
												deleteImage("secondCatImage")
											}}
											aria-label=""
										/></>)}
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Category Link" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											label=""
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.secondCatLink}
											onChange={(e) => handleInputChangeUrl(e, "secondCatLink")}
											name="secondCatLink"
											error={errors && errors.secondCatLink ? true : false
											}
											helperText={errors && errors.secondCatLink ? errors.secondCatLink : ""}
										/>
									</div>
								</div>
							</ListItem>
						</>}
						{(editType == "sectionThird" || editType == "mainSettings") && <><h4><b>Category Three</b></h4>
							<hr />

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-thirdCatMainText" primary="Main Text" />
									</div>
									<div className="col-md-9 form-group">
										<JoditEditor
											ref={editor}
											value={inputs.thirdCatMainText}
											config={TextEditorConfig}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.thirdCatMainText = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Main Text Font Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="thirdCatMainTextColor"
											defaultValue="#000"
											value={inputs.thirdCatMainTextColor}
											onChange={color => { handleColorPicker('thirdCatMainTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.thirdCatMainTextColor != undefined && inputs.thirdCatMainTextColor != "undefined" && (inputs.thirdCatMainTextColor)}</p>
										{inputs.thirdCatMainTextColor != "undefined" &&
											inputs.thirdCatMainTextColor != undefined &&
											inputs.thirdCatMainTextColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'thirdCatMainTextColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-thirdCatMainTextFont" primary="Main Text Font" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.thirdCatMainTextFont = "" ? " " : inputs.thirdCatMainTextFont}
												onChange={handleInputChange}
												name="thirdCatMainTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-thirdCatMainTextFontSize" primary="Main Text Font Size" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.thirdCatMainTextFontSize}
											onChange={handleInputChange}
											name="thirdCatMainTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.thirdCatMainTextFontSize ? errors.thirdCatMainTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-thirdCatText" primary="Text" />
									</div>
									<div className="col-md-9 form-group">
										<JoditEditor
											ref={editor}
											value={inputs.thirdCatText}
											config={TextEditorConfig}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.thirdCatText = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>

							</ListItem>

							{/* <ListItem className="mb-15">
								<ListItemText id="switch-list-label-wifi" primary="Text Font Color" />
								<div className="col-lg-4">
									<ColorPicker
										name="thirdCatTextColor"
										defaultValue="#000"
										value={inputs.thirdCatTextColor}
										onChange={color => { handleColorPicker('thirdCatTextColor', color) }}
									/>
								</div>
								<div className="col-lg-3">
									<p>{inputs.thirdCatTextColor != undefined && (inputs.thirdCatTextColor)}</p>
								</div>
							</ListItem> */}

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Text Font Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="thirdCatTextColor"
											defaultValue="#000"
											value={inputs.thirdCatTextColor}
											onChange={color => { handleColorPicker('thirdCatTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.thirdCatTextColor != undefined && inputs.thirdCatTextColor != "undefined" && (inputs.thirdCatTextColor)}</p>
										{inputs.thirdCatTextColor != "undefined" &&
											inputs.thirdCatTextColor != undefined &&
											inputs.thirdCatTextColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'thirdCatTextColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-thirdCatTextFont" primary="Text Font" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.thirdCatTextFont == "" ? " " : inputs.thirdCatTextFont}
												onChange={handleInputChange}
												name="thirdCatTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-thirdCatTextFontSize" primary="Text Font Size" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.thirdCatTextFontSize}
											onChange={handleInputChange}
											name="thirdCatTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.thirdCatTextFontSize ? errors.thirdCatTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-thirdCatPriceText" primary="Sub Text" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="text"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.thirdCatPriceText}
											onChange={handleInputChange}
											name="thirdCatPriceText"
										/>
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Sub Text Font Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="thirdCatPriceTextColor"
											defaultValue="#000"
											value={inputs.thirdCatPriceTextColor}
											onChange={color => { handleColorPicker('thirdCatPriceTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.thirdCatPriceTextColor != undefined && inputs.thirdCatPriceTextColor != "undefined" && (inputs.thirdCatPriceTextColor)}</p>
										{inputs.thirdCatPriceTextColor != "undefined" &&
											inputs.thirdCatPriceTextColor != undefined &&
											inputs.thirdCatPriceTextColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'thirdCatPriceTextColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-thirdCatPriceTextFont" primary="Sub Text Font" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.thirdCatPriceTextFont == "" ? " " : inputs.thirdCatPriceTextFont}
												onChange={handleInputChange}
												name="thirdCatPriceTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-thirdCatPriceTextFontSize" primary="Sub Text Font Size" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.thirdCatPriceTextFontSize}
											onChange={handleInputChange}
											name="thirdCatPriceTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.thirdCatPriceTextFontSize ? errors.thirdCatPriceTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Image" />
									</div>
									<div className="col-lg-4">
										<input onChange={(e) => setImageFile(e, 'thirdCatImage')}
											type="file"
											name="thirdCatImage"
											accept="image/*"
										/>
									</div>
									<div className="col-lg-4"> {inputs.thirdCatImage != "" && (<>
										<img height="50px" width="50px" src={inputs.thirdCatImage}></img>
										<DeleteIcon
											className="text-error"
											title={"Delete"}
											onClick={() => {
												deleteImage("thirdCatImage")
											}}
											aria-label=""
										/></>)}
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Category Link" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											label=""
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.thirdCatLink}
											onChange={(e) => handleInputChangeUrl(e, "thirdCatLink")}
											name="thirdCatLink"
											error={errors && errors.thirdCatLink ? true : false
											}
											helperText={errors && errors.thirdCatLink ? errors.thirdCatLink : ""}
										/>
									</div>
								</div>
							</ListItem>
						</>}
						{(editType == "sectionFourth" || editType == "mainSettings") && <> <h4><b>Category Four</b></h4>
							<hr />

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-firstCatMainText" primary="Main Text" />
									</div>
									<div className="col-md-9 form-group">
										<JoditEditor
											ref={editor}
											value={inputs.fourthCatMainText}
											config={TextEditorConfig}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.fourthCatMainText = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>

							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Main Text Font Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="fourthCatMainTextColor"
											defaultValue="#000"
											value={inputs.fourthCatMainTextColor}
											onChange={color => { handleColorPicker('fourthCatMainTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.fourthCatMainTextColor != undefined && inputs.fourthCatMainTextColor != "undefined" && (inputs.fourthCatMainTextColor)}</p>
										{inputs.fourthCatMainTextColor != "undefined" &&
											inputs.fourthCatMainTextColor != undefined &&
											inputs.fourthCatMainTextColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'fourthCatMainTextColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-fourthCatMainTextFont" primary="Main Text Font" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.fourthCatMainTextFont == "" ? " " : inputs.fourthCatMainTextFont}
												onChange={handleInputChange}
												name="fourthCatMainTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-fourthCatMainTextFontSize" primary="Main Text Font Size" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.fourthCatMainTextFontSize}
											onChange={handleInputChange}
											name="fourthCatMainTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.fourthCatMainTextFontSize ? errors.fourthCatMainTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-firstCatMainText" primary="Text" />
									</div>
									<div className="col-md-9 form-group">
										<JoditEditor
											ref={editor}
											value={inputs.fourthCatText}
											config={TextEditorConfig}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.fourthCatText = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>

							</ListItem>

							{/* <ListItem className="mb-15">
								<ListItemText id="switch-list-label-wifi" primary="Text Font Color" />
								<div className="col-lg-4">
									<ColorPicker
										name="fourthCatTextColor"
										defaultValue="#000"
										value={inputs.fourthCatTextColor}
										onChange={color => { handleColorPicker('fourthCatTextColor', color) }}
									/>
								</div>
								<div className="col-lg-3">
									<p>{inputs.fourthCatTextColor != undefined && (inputs.fourthCatTextColor)}</p>
								</div>
							</ListItem> */}

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Text Font Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="fourthCatTextColor"
											defaultValue="#000"
											value={inputs.fourthCatTextColor}
											onChange={color => { handleColorPicker('fourthCatTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.fourthCatTextColor != undefined && inputs.fourthCatTextColor != "undefined" && (inputs.fourthCatTextColor)}</p>
										{inputs.fourthCatTextColor != "undefined" &&
											inputs.fourthCatTextColor != undefined &&
											inputs.fourthCatTextColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'fourthCatTextColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-fourthCatTextFont" primary="Text Font" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.fourthCatTextFont == "" ? " " : inputs.fourthCatTextFont}
												onChange={handleInputChange}
												name="fourthCatTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-fourthCatTextFontSize" primary="Text Font Size" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.fourthCatTextFontSize}
											onChange={handleInputChange}
											name="fourthCatTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.fourthCatTextFontSize ? errors.fourthCatTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>

							{/* <ListItem className="mb-15">
								<ListItemText id="switch-fourthCatPriceText" primary="Sub Text" />
								<TextField
									id="outlined-basic"
									type="text"
									size="medium"
									variant="outlined"
									fullWidth
									className={classes.textField}
									value={inputs.fourthCatPriceText}
									onChange={handleInputChange}
									name="fourthCatPriceText"
								/>
							</ListItem> */}

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-firstCatMainText" primary="Sub Text" />
									</div>
									<div className="col-md-9 form-group">
										<JoditEditor
											ref={editor}
											value={inputs.fourthCatPriceText}
											config={TextEditorConfig}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.fourthCatPriceText = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>

							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Sub Text Font Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="fourthCatPriceTextColor"
											defaultValue="#000"
											value={inputs.fourthCatPriceTextColor}
											onChange={color => { handleColorPicker('fourthCatPriceTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.fourthCatPriceTextColor != undefined && inputs.fourthCatPriceTextColor != "undefined" && (inputs.fourthCatPriceTextColor)}</p>
										{inputs.fourthCatPriceTextColor != "undefined" &&
											inputs.fourthCatPriceTextColor != undefined &&
											inputs.fourthCatPriceTextColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'fourthCatPriceTextColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-fourthCatPriceTextFont" primary="Sub Text Font" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.fourthCatPriceTextFont == "" ? " " : inputs.fourthCatPriceTextFont}
												onChange={handleInputChange}
												name="fourthCatPriceTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-fourthCatPriceTextFontSize" primary="Sub Text Font Size" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.fourthCatPriceTextFontSize}
											onChange={handleInputChange}
											name="fourthCatPriceTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.fourthCatPriceTextFontSize ? errors.fourthCatPriceTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Image" />
									</div>
									<div className="col-lg-4">
										<input onChange={(e) => setImageFile(e, 'fourthCatImage')}
											type="file"
											name="fourthCatImage"
											accept="image/*"
										/>
									</div>
									<div className="col-lg-4"> {inputs.fourthCatImage != "" && (<>
										<img height="50px" width="50px" src={inputs.fourthCatImage}></img>
										<DeleteIcon
											className="text-error"
											title={"Delete"}
											onClick={() => {
												deleteImage("fourthCatImage")
											}}
											aria-label=""
										/></>)}
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Category Link" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											label=""
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.fourthCatLink}
											onChange={(e) => handleInputChangeUrl(e, "fourthCatLink")}
											name="fourthCatLink"
											error={errors && errors.fourthCatLink ? true : false
											}
											helperText={errors && errors.fourthCatLink ? errors.fourthCatLink : ""}
										/>
									</div>
								</div>
							</ListItem>
						</>}
						{(editType == "sectionFifth" || editType == "mainSettings") && <> <h4><b>Category Five</b></h4>
							<hr />

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-firstCatMainText" primary="Main Text" />
									</div>
									<div className="col-md-9 form-group">
										<JoditEditor
											ref={editor}
											value={inputs.fifthCatMainText}
											config={TextEditorConfig}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.fifthCatMainText = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Main Text Font Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="fifthCatMainTextColor"
											defaultValue="#000"
											value={inputs.fifthCatMainTextColor}
											onChange={color => { handleColorPicker('fifthCatMainTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.fifthCatMainTextColor != undefined && inputs.fifthCatMainTextColor != "undefined" && (inputs.fifthCatMainTextColor)}</p>
										{inputs.fifthCatMainTextColor != "undefined" &&
											inputs.fifthCatMainTextColor != undefined &&
											inputs.fifthCatMainTextColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'fifthCatMainTextColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-fifthCatMainTextFont" primary="Main Text Font" />
									</div>
									<div className="col-md-3 form-group">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.fifthCatMainTextFont == "" ? " " : inputs.fifthCatMainTextFont}
												onChange={handleInputChange}
												name="fifthCatMainTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-fifthCatMainTextFontSize" primary="Main Text Font Size" />
									</div>
									<div className="col-md-9 form-group">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.fifthCatMainTextFontSize}
											onChange={handleInputChange}
											name="fifthCatMainTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.fifthCatMainTextFontSize ? errors.fifthCatMainTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-firstCatMainText" primary="Text" />
									</div>
									<div className="col-md-9 form-group">
										<JoditEditor
											ref={editor}
											value={inputs.fifthCatText}
											config={TextEditorConfig}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.fifthCatText = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Text Font Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="fifthCatTextColor"
											defaultValue="#000"
											value={inputs.fifthCatTextColor}
											onChange={color => { handleColorPicker('fifthCatTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.fifthCatTextColor != undefined && inputs.fifthCatTextColor != "undefined" && (inputs.fifthCatTextColor)}</p>
										{inputs.fifthCatTextColor != "undefined" &&
											inputs.fifthCatTextColor != undefined &&
											inputs.fifthCatTextColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'fifthCatTextColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-fifthCatTextFont" primary="Text Font" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.fifthCatTextFont == "" ? " " : inputs.fifthCatTextFont}
												onChange={handleInputChange}
												name="fifthCatTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-fifthCatTextFontSize" primary="Text Font Size" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.fifthCatTextFontSize}
											onChange={handleInputChange}
											name="fifthCatTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.fifthCatTextFontSize ? errors.fifthCatTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-firstCatMainText" primary="Sub Text" />
									</div>
									<div className="col-md-9 form-group">
										<JoditEditor
											ref={editor}
											value={inputs.fifthCatPriceText}
											config={TextEditorConfig}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.fifthCatPriceText = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>

							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Sub Text Font Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="fifthCatPriceTextColor"
											defaultValue="#000"
											value={inputs.fifthCatPriceTextColor}
											onChange={color => { handleColorPicker('fifthCatPriceTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.fifthCatPriceTextColor != undefined && inputs.fifthCatPriceTextColor != "undefined" && (inputs.fifthCatPriceTextColor)}</p>
										{inputs.fifthCatPriceTextColor != "undefined" &&
											inputs.fifthCatPriceTextColor != undefined &&
											inputs.fifthCatPriceTextColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'fifthCatPriceTextColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-fifthCatPriceTextFont" primary="Sub Text Font" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.fifthCatPriceTextFont == "" ? " " : inputs.fifthCatPriceTextFont}
												onChange={handleInputChange}
												name="fifthCatPriceTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-fifthCatPriceTextFontSize" primary="Sub Text Font Size" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.fifthCatPriceTextFontSize}
											onChange={handleInputChange}
											name="fifthCatPriceTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.fifthCatPriceTextFontSize ? errors.fifthCatPriceTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Image" />
									</div>
									<div className="col-lg-4">
										<input onChange={(e) => setImageFile(e, 'fifthCatImage')}
											type="file"
											name="fifthCatImage"
											accept="image/*"
										/>
									</div>
									<div className="col-lg-4"> {inputs.fifthCatImage != "" && (<>
										<img height="50px" width="50px" src={inputs.fifthCatImage}></img>
										<DeleteIcon
											className="text-error"
											title={"Delete"}
											onClick={() => {
												deleteImage("fifthCatImage")
											}}
											aria-label=""
										/></>)}
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Category Link" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											label=""
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.fifthCatLink}
											onChange={(e) => handleInputChangeUrl(e, "fifthCatLink")}
											name="fifthCatLink"
											error={errors && errors.fifthCatLink ? true : false
											}
											helperText={errors && errors.fifthCatLink ? errors.fifthCatLink : ""}
										/>
									</div>
								</div>
							</ListItem>
						</>}
						{(editType == "sectionSix" || editType == "mainSettings") && <> <h4><b>Category Six</b></h4>
							<hr />

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-firstCatMainText" primary="Main Text" />
									</div>
									<div className="col-md-9 form-group">
										<JoditEditor
											ref={editor}
											value={inputs.sixthCatMainText}
											config={TextEditorConfig}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.sixthCatMainText = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>

							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Main Text Font Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="nameFontColor"
											defaultValue="#000"
											value={inputs.sixthCatMainTextColor}
											onChange={color => { handleColorPicker('sixthCatMainTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.sixthCatMainTextColor != undefined && inputs.sixthCatMainTextColor != "undefined" && (inputs.sixthCatMainTextColor)}</p>
										{inputs.sixthCatMainTextColor != "undefined" &&
											inputs.sixthCatMainTextColor != undefined &&
											inputs.sixthCatMainTextColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'sixthCatMainTextColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-sixthCatMainTextFont" primary="Main Text Font" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.sixthCatMainTextFont == "" ? " " : inputs.sixthCatMainTextFont}
												onChange={handleInputChange}
												name="sixthCatMainTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-sixthCatMainTextFontSize" primary="Main Text Font Size" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.sixthCatMainTextFontSize}
											onChange={handleInputChange}
											name="sixthCatMainTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.sixthCatMainTextFontSize ? errors.sixthCatMainTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>
							{/* <ListItem className="mb-15">
								<ListItemText id="switch-sixthCatText" primary="Text" />
								<TextField
									id="outlined-basic"
									type="text"
									size="medium"
									variant="outlined"
									fullWidth
									className={classes.textField}
									value={inputs.sixthCatText}
									onChange={handleInputChange}
									name="sixthCatText"
								/>
							</ListItem> */}

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-firstCatMainText" primary="Text" />
									</div>
									<div className="col-md-9 form-group">
										<JoditEditor
											ref={editor}
											value={inputs.sixthCatText}
											config={TextEditorConfig}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.sixthCatText = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>

							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Text Font Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="sixthCatTextColor"
											defaultValue="#000"
											value={inputs.sixthCatTextColor}
											onChange={color => { handleColorPicker('sixthCatTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.sixthCatTextColor != undefined && inputs.sixthCatTextColor != "undefined" && (inputs.sixthCatTextColor)}</p>
										{inputs.sixthCatTextColor != "undefined" &&
											inputs.sixthCatTextColor != undefined &&
											inputs.sixthCatTextColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'sixthCatTextColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-sixthCatTextFont" primary="Text Font" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.sixthCatTextFont == "" ? " " : inputs.sixthCatTextFont}
												onChange={handleInputChange}
												name="sixthCatTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-sixthCatTextFontSize" primary="Text Font Size" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.sixthCatTextFontSize}
											onChange={handleInputChange}
											name="sixthCatTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.sixthCatTextFontSize ? errors.sixthCatTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-firstCatMainText" primary="Sub Text" />
									</div>
									<div className="col-md-9 form-group">
										<JoditEditor
											ref={editor}
											value={inputs.sixthCatPriceText}
											config={TextEditorConfig}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.sixthCatPriceText = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Sub Text Font Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="sixthCatPriceTextColor"
											defaultValue="#000"
											value={inputs.sixthCatPriceTextColor}
											onChange={color => { handleColorPicker('sixthCatPriceTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.sixthCatPriceTextColor != undefined && inputs.sixthCatPriceTextColor != "undefined" && (inputs.sixthCatPriceTextColor)}</p>
										{inputs.sixthCatPriceTextColor != "undefined" &&
											inputs.sixthCatPriceTextColor != undefined &&
											inputs.sixthCatPriceTextColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'sixthCatPriceTextColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-sixthCatPriceTextFont" primary="Sub Text Font" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.sixthCatPriceTextFont == "" ? " " : inputs.sixthCatPriceTextFont}
												onChange={handleInputChange}
												name="sixthCatPriceTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-sixthCatPriceTextFontSize" primary="Sub Text Font Size" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.sixthCatPriceTextFontSize}
											onChange={handleInputChange}
											name="sixthCatPriceTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.sixthCatPriceTextFontSize ? errors.sixthCatPriceTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Image" />
									</div>
									<div className="col-lg-4">
										<input onChange={(e) => setImageFile(e, 'sixthCatImage')}
											type="file"
											name="sixthCatImage"
											accept="image/*"
										/>
									</div>
									<div className="col-lg-4"> {inputs.sixthCatImage != "" && (<>
										<img height="50px" width="50px" src={inputs.sixthCatImage}></img>
										<DeleteIcon
											className="text-error"
											title={"Delete"}
											onClick={() => {
												deleteImage("sixthCatImage")
											}}
											aria-label=""
										/></>)}
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Category Link" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											label=""
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.sixthCatLink}
											onChange={(e) => handleInputChangeUrl(e, "sixthCatLink")}
											name="sixthCatLink"
											error={errors && errors.sixthCatLink ? true : false
											}
											helperText={errors && errors.sixthCatLink ? errors.sixthCatLink : ""}
										/>
									</div>
								</div>
							</ListItem>
						</>}

						{(editType == "sectionSeven" || editType == "mainSettings") && <> <h4><b>Category Seven</b></h4>
							<hr />

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-firstCatMainText" primary="Main Text" />
									</div>
									<div className="col-md-9 form-group">
										<JoditEditor
											ref={editor}
											value={inputs.seventhCatMainText}
											config={TextEditorConfig}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.seventhCatMainText = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>

							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Main Text Font Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="nameFontColor"
											defaultValue="#000"
											value={inputs.seventhCatMainTextColor}
											onChange={color => { handleColorPicker('seventhCatMainTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.seventhCatMainTextColor != undefined && inputs.seventhCatMainTextColor != "undefined" && (inputs.seventhCatMainTextColor)}</p>
										{inputs.seventhCatMainTextColor != "undefined" &&
											inputs.seventhCatMainTextColor != undefined &&
											inputs.seventhCatMainTextColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'seventhCatMainTextColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-sixthCatMainTextFont" primary="Main Text Font" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.seventhCatMainTextFont == "" ? " " : inputs.seventhCatMainTextFont}
												onChange={handleInputChange}
												name="seventhCatMainTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-sixthCatMainTextFontSize" primary="Main Text Font Size" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.seventhCatMainTextFontSize}
											onChange={handleInputChange}
											name="seventhCatMainTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.seventhCatMainTextFontSize ? errors.seventhCatMainTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>
							{/* <ListItem className="mb-15">
								<ListItemText id="switch-sixthCatText" primary="Text" />
								<TextField
									id="outlined-basic"
									type="text"
									size="medium"
									variant="outlined"
									fullWidth
									className={classes.textField}
									value={inputs.sixthCatText}
									onChange={handleInputChange}
									name="sixthCatText"
								/>
							</ListItem> */}

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-firstCatMainText" primary="Text" />
									</div>
									<div className="col-md-9 form-group">
										<JoditEditor
											ref={editor}
											value={inputs.seventhCatText}
											config={TextEditorConfig}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.seventhCatText = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>

							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Text Font Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="seventhCatTextColor"
											defaultValue="#000"
											value={inputs.seventhCatTextColor}
											onChange={color => { handleColorPicker('seventhCatTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.seventhCatTextColor != undefined && inputs.seventhCatTextColor != "undefined" && (inputs.seventhCatTextColor)}</p>
										{inputs.seventhCatTextColor != "undefined" &&
											inputs.seventhCatTextColor != undefined &&
											inputs.seventhCatTextColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'seventhCatTextColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-seventhCatTextFont" primary="Text Font" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.seventhCatTextFont == "" ? " " : inputs.seventhCatTextFont}
												onChange={handleInputChange}
												name="seventhCatTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-sixthCatTextFontSize" primary="Text Font Size" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.seventhCatTextFontSize}
											onChange={handleInputChange}
											name="seventhCatTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.seventhCatTextFontSize ? errors.seventhCatTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-firstCatMainText" primary="Sub Text" />
									</div>
									<div className="col-md-9 form-group">
										<JoditEditor
											ref={editor}
											value={inputs.seventhCatPriceText}
											config={TextEditorConfig}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.seventhCatPriceText = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Sub Text Font Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="seventhCatPriceTextColor"
											defaultValue="#000"
											value={inputs.seventhCatPriceTextColor}
											onChange={color => { handleColorPicker('seventhCatPriceTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.seventhCatPriceTextColor != undefined && inputs.seventhCatPriceTextColor != "undefined" && (inputs.seventhCatPriceTextColor)}</p>
										{inputs.seventhCatPriceTextColor != "undefined" &&
											inputs.seventhCatPriceTextColor != undefined &&
											inputs.seventhCatPriceTextColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'seventhCatPriceTextColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-sixthCatPriceTextFont" primary="Sub Text Font" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.seventhCatPriceTextFont == "" ? " " : inputs.seventhCatPriceTextFont}
												onChange={handleInputChange}
												name="seventhCatPriceTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-sixthCatPriceTextFontSize" primary="Sub Text Font Size" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.seventhCatPriceTextFontSize}
											onChange={handleInputChange}
											name="seventhCatPriceTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.sixthCatPriceTextFontSize ? errors.sixthCatPriceTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Image" />
									</div>
									<div className="col-lg-4">
										<input onChange={(e) => setImageFile(e, 'seventhCatImage')}
											type="file"
											name="seventhCatImage"
											accept="image/*"
										/>
									</div>
									<div className="col-lg-4"> {inputs.seventhCatImage != "" && (<>
										<img height="50px" width="50px" src={inputs.seventhCatImage}></img>
										<DeleteIcon
											className="text-error"
											title={"Delete"}
											onClick={() => {
												deleteImage("seventhCatImage")
											}}
											aria-label=""
										/></>)}
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Category Link" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											label=""
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.seventhCatLink}
											onChange={(e) => handleInputChangeUrl(e, "seventhCatLink")}
											name="seventhCatLink"
											error={errors && errors.seventhCatLink ? true : false
											}
											helperText={errors && errors.seventhCatLink ? errors.seventhCatLink : ""}
										/>
									</div>
								</div>
							</ListItem>
						</>}

						{(editType == "sectionEight" || editType == "mainSettings") && <> <h4><b>Category Eight</b></h4>
							<hr />

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-firstCatMainText" primary="Main Text" />
									</div>
									<div className="col-md-9 form-group">
										<JoditEditor
											ref={editor}
											value={inputs.eightCatMainText}
											config={TextEditorConfig}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.eightCatMainText = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>

							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Main Text Font Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="nameFontColor"
											defaultValue="#000"
											value={inputs.eightCatMainTextColor}
											onChange={color => { handleColorPicker('eightCatMainTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.eightCatMainTextColor != undefined && inputs.eightCatMainTextColor != "undefined" && (inputs.eightCatMainTextColor)}</p>
										{inputs.eightCatMainTextColor != "undefined" &&
											inputs.eightCatMainTextColor != undefined &&
											inputs.eightCatMainTextColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'eightCatMainTextColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-eightCatMainTextFont" primary="Main Text Font" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.eightCatMainTextFont == "" ? " " : inputs.eightCatMainTextFont}
												onChange={handleInputChange}
												name="eightCatMainTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-eightCatMainTextFontSize" primary="Main Text Font Size" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.eightCatMainTextFontSize}
											onChange={handleInputChange}
											name="eightCatMainTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.seventhCatMainTextFontSize ? errors.seventhCatMainTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>
							{/* <ListItem className="mb-15">
								<ListItemText id="switch-sixthCatText" primary="Text" />
								<TextField
									id="outlined-basic"
									type="text"
									size="medium"
									variant="outlined"
									fullWidth
									className={classes.textField}
									value={inputs.sixthCatText}
									onChange={handleInputChange}
									name="sixthCatText"
								/>
							</ListItem> */}

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-firstCatMainText" primary="Text" />
									</div>
									<div className="col-md-9 form-group">
										<JoditEditor
											ref={editor}
											value={inputs.eightCatText}
											config={TextEditorConfig}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.eightCatText = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>

							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Text Font Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="eightCatTextColor"
											defaultValue="#000"
											value={inputs.eightCatTextColor}
											onChange={color => { handleColorPicker('eightCatTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.eightCatTextColor != undefined && inputs.eightCatTextColor != "undefined" && (inputs.eightCatTextColor)}</p>
										{inputs.eightCatTextColor != "undefined" &&
											inputs.eightCatTextColor != undefined &&
											inputs.eightCatTextColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'eightCatTextColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-eightCatTextFont" primary="Text Font" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.eightCatTextFont == "" ? " " : inputs.eightCatTextFont}
												onChange={handleInputChange}
												name="eightCatTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-eightCatTextFontSize" primary="Text Font Size" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.eightCatTextFontSize}
											onChange={handleInputChange}
											name="eightCatTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.seventhCatTextFontSize ? errors.seventhCatTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-firstCatMainText" primary="Sub Text" />
									</div>
									<div className="col-md-9 form-group">
										<JoditEditor
											ref={editor}
											value={inputs.eightCatPriceText}
											config={TextEditorConfig}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.eightCatPriceText = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Sub Text Font Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="eightCatPriceTextColor"
											defaultValue="#000"
											value={inputs.eightCatPriceTextColor}
											onChange={color => { handleColorPicker('eightCatPriceTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.eightCatPriceTextColor != undefined && inputs.eightCatPriceTextColor != "undefined" && (inputs.eightCatPriceTextColor)}</p>
										{inputs.eightCatPriceTextColor != "undefined" &&
											inputs.eightCatPriceTextColor != undefined &&
											inputs.eightCatPriceTextColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'eightCatPriceTextColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-sixthCatPriceTextFont" primary="Sub Text Font" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.eightCatPriceTextFont == "" ? " " : inputs.eightCatPriceTextFont}
												onChange={handleInputChange}
												name="eightCatPriceTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-eightCatPriceTextFontSize" primary="Sub Text Font Size" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.eightCatPriceTextFontSize}
											onChange={handleInputChange}
											name="eightCatPriceTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.sixthCatPriceTextFontSize ? errors.sixthCatPriceTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Image" />
									</div>
									<div className="col-lg-4">
										<input onChange={(e) => setImageFile(e, 'eightCatImage')}
											type="file"
											name="eightCatImage"
											accept="image/*"
										/>
									</div>
									<div className="col-lg-4"> {inputs.eightCatImage != "" && (<>
										<img height="50px" width="50px" src={inputs.eightCatImage}></img>
										<DeleteIcon
											className="text-error"
											title={"Delete"}
											onClick={() => {
												deleteImage("eightCatImage")
											}}
											aria-label=""
										/></>)}
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Category Link" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											label=""
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.eightCatLink}
											onChange={(e) => handleInputChangeUrl(e, "eightCatLink")}
											name="eightCatLink"
											error={errors && errors.eightCatLink ? true : false
											}
											helperText={errors && errors.eightCatLink ? errors.eightCatLink : ""}
										/>
									</div>
								</div>
							</ListItem>
						</>}

						{(editType == "sectionNine" || editType == "mainSettings") && <> <h4><b>Category Nine</b></h4>
							<hr />

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-firstCatMainText" primary="Main Text" />
									</div>
									<div className="col-md-9 form-group">
										<JoditEditor
											ref={editor}
											value={inputs.nineCatMainText}
											config={TextEditorConfig}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.nineCatMainText = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>

							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Main Text Font Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="nameFontColor"
											defaultValue="#000"
											value={inputs.nineCatMainTextColor}
											onChange={color => { handleColorPicker('nineCatMainTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.nineCatMainTextColor != undefined && inputs.nineCatMainTextColor != "undefined" && (inputs.nineCatMainTextColor)}</p>
										{inputs.nineCatMainTextColor != "undefined" &&
											inputs.nineCatMainTextColor != undefined &&
											inputs.nineCatMainTextColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'nineCatMainTextColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-eightCatMainTextFont" primary="Main Text Font" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.nineCatMainTextFont == "" ? " " : inputs.nineCatMainTextFont}
												onChange={handleInputChange}
												name="nineCatMainTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-eightCatMainTextFontSize" primary="Main Text Font Size" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.nineCatMainTextFontSize}
											onChange={handleInputChange}
											name="nineCatMainTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.seventhCatMainTextFontSize ? errors.seventhCatMainTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>
							{/* <ListItem className="mb-15">
								<ListItemText id="switch-sixthCatText" primary="Text" />
								<TextField
									id="outlined-basic"
									type="text"
									size="medium"
									variant="outlined"
									fullWidth
									className={classes.textField}
									value={inputs.sixthCatText}
									onChange={handleInputChange}
									name="sixthCatText"
								/>
							</ListItem> */}

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-firstCatMainText" primary="Text" />
									</div>
									<div className="col-md-9 form-group">
										<JoditEditor
											ref={editor}
											value={inputs.nineCatText}
											config={TextEditorConfig}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.nineCatText = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>

							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Text Font Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="nineCatTextColor"
											defaultValue="#000"
											value={inputs.nineCatTextColor}
											onChange={color => { handleColorPicker('nineCatTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.nineCatTextColor != undefined && inputs.nineCatTextColor != "undefined" && (inputs.nineCatTextColor)}</p>
										{inputs.nineCatTextColor != "undefined" &&
											inputs.nineCatTextColor != undefined &&
											inputs.nineCatTextColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'nineCatTextColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-eightCatTextFont" primary="Text Font" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.nineCatTextFont == "" ? " " : inputs.nineCatTextFont}
												onChange={handleInputChange}
												name="nineCatTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-eightCatTextFontSize" primary="Text Font Size" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.ninetCatTextFontSize}
											onChange={handleInputChange}
											name="nineCatTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.seventhCatTextFontSize ? errors.seventhCatTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-md-3 form-group">
										<ListItemText id="switch-firstCatMainText" primary="Sub Text" />
									</div>
									<div className="col-md-9 form-group">
										<JoditEditor
											ref={editor}
											value={inputs.nineCatPriceText}
											config={TextEditorConfig}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.nineCatPriceText = bodyOfEditor
												setTemp('0');
											}}
										/>
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Sub Text Font Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="nineCatPriceTextColor"
											defaultValue="#000"
											value={inputs.nineCatPriceTextColor}
											onChange={color => { handleColorPicker('nineCatPriceTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.nineCatPriceTextColor != undefined && inputs.nineCatPriceTextColor != "undefined" && (inputs.nineCatPriceTextColor)}</p>
										{inputs.nineCatPriceTextColor != "undefined" &&
											inputs.nineCatPriceTextColor != undefined &&
											inputs.nineCatPriceTextColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'nineCatPriceTextColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-sixthCatPriceTextFont" primary="Sub Text Font" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.nineCatPriceTextFont == "" ? " " : inputs.nineCatPriceTextFont}
												onChange={handleInputChange}
												name="nineCatPriceTextFont">
												<MenuItem value=" ">Default</MenuItem>
												{FONT_FAMILY && FONT_FAMILY.length && Object.keys(FONT_FAMILY).map((data, index) => {
													return <MenuItem style={{ fontFamily: FONT_FAMILY[data].label }} key={index} value={FONT_FAMILY[data].value}> {FONT_FAMILY[data].label}</MenuItem>
												})}
												{!FONT_FAMILY.length && (<MenuItem value=" "> No Font Family</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-eightCatPriceTextFontSize" primary="Sub Text Font Size" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.nineCatPriceTextFontSize}
											onChange={handleInputChange}
											name="nineCatPriceTextFontSize"
										/>
										<p style={errorClass}>{errors && errors.sixthCatPriceTextFontSize ? errors.sixthCatPriceTextFontSize : ""}</p>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Image" />
									</div>
									<div className="col-lg-4">
										<input onChange={(e) => setImageFile(e, 'nineCatImage')}
											type="file"
											name="nineCatImage"
											accept="image/*"
										/>
									</div>
									<div className="col-lg-4"> {inputs.nineCatImage != "" && (<>
										<img height="50px" width="50px" src={inputs.nineCatImage}></img>
										<DeleteIcon
											className="text-error"
											title={"Delete"}
											onClick={() => {
												deleteImage("nineCatImage")
											}}
											aria-label=""
										/></>)}
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Category Link" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											label=""
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.nineCatLink}
											onChange={(e) => handleInputChangeUrl(e, "nineCatLink")}
											name="nineCatLink"
											error={errors && errors.nineCatLink ? true : false
											}
											helperText={errors && errors.eightCatLink ? errors.eightCatLink : ""}
										/>
									</div>
								</div>
							</ListItem>
						</>}


						{editType == "mainSettings" && <> <h4><b>Design Settings</b></h4>
							<hr />
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Image box size" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.imageBoxSize}
											onChange={handleInputChange}
											name="imageBoxSize"
										/>%
										<p style={errorClass}>{errors && errors.imageBoxSize ? errors.imageBoxSize : ""}</p>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Space between boxes" />
									</div>
									<div className="col-lg-9">
										<TextField
											id="outlined-basic"
											type="number"
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.spaceBetweenBox}
											onChange={handleInputChange}
											name="spaceBetweenBox"
										/>%
										<p style={errorClass}>{errors && errors.spaceBetweenBox ? errors.spaceBetweenBox : ""}</p>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-firstCatMainTextFont" primary="Select Icon" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.linkIcon}
												onChange={handleInputChange}
												name="linkIcon">
												<MenuItem value="">Select Icon</MenuItem>
												{ICON && ICON.length && Object.keys(ICON).map((data, index) => {
													return <MenuItem key={index} value={ICON[data].value}>
														<i className={`${ICON[data].label}`} />
													</MenuItem>
												})}
												{!ICON.length && (<MenuItem value=""> No Data</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-firstCatMainTextFont" primary="Show Icon" />
									</div>
									<div className="col-lg-9">
										<Switch color="primary" checked={inputs.showIcon} onChange={(e) => handleInputSwitchChange(e, "showIcon")} />
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Icon Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="iconColor"
											defaultValue="#000"
											value={inputs.iconColor}
											onChange={color => { handleColorPicker('iconColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.iconColor != undefined && inputs.iconColor != "undefined" && (inputs.iconColor)}</p>
										{inputs.iconColor != "undefined" &&
											inputs.iconColor != undefined &&
											inputs.iconColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'iconColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText className="" id="switch-list-label-wifi" primary="Icon Hover Color" />
									</div>
									<div className="col-lg-2">
										<ColorPicker
											name="iconHoverColor"
											defaultValue="#000"
											value={inputs.iconHoverColor}
											onChange={color => { handleColorPicker('iconHoverColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0 pl-70">{inputs.iconHoverColor != undefined && inputs.iconHoverColor != "undefined" && (inputs.iconHoverColor)}</p>
										{inputs.iconHoverColor != "undefined" &&
											inputs.iconHoverColor != undefined &&
											inputs.iconHoverColor != "" && (
												<DeleteIcon
													className="text-error ml-4"
													title={"Reset"}
													onClick={() => {
														resetColor("", 'iconHoverColor')
													}}
													aria-label=""
												/>)}
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Padding Top" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.paddingTop}
												onChange={handleInputChange}
												name="paddingTop">
												{CLASSNAME_P_T && CLASSNAME_P_T.length && Object.keys(CLASSNAME_P_T).map((data, index) => {
													return <MenuItem value={CLASSNAME_P_T[data].value}> {CLASSNAME_P_T[data].label}</MenuItem>
												})}
												{!CLASSNAME_P_T.length && (<MenuItem value=" "> No Data</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>

							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Padding Bottom" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.paddingBottom}
												onChange={handleInputChange}
												name="paddingBottom">
												{CLASSNAME_P_B && CLASSNAME_P_B.length && Object.keys(CLASSNAME_P_B).map((data, index) => {
													return <MenuItem value={CLASSNAME_P_B[data].value}> {CLASSNAME_P_B[data].label}</MenuItem>
												})}
												{!CLASSNAME_P_B.length && (<MenuItem value=" "> No Data</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Padding Left" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.paddingLeft}
												onChange={handleInputChange}
												name="paddingLeft">
												{CLASSNAME_P_L && CLASSNAME_P_L.length && Object.keys(CLASSNAME_P_L).map((data, index) => {
													return <MenuItem value={CLASSNAME_P_L[data].value}> {CLASSNAME_P_L[data].label}</MenuItem>
												})}
												{!CLASSNAME_P_L.length && (<MenuItem value=" "> No Data</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Padding Right" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.paddingRight}
												onChange={handleInputChange}
												name="paddingRight">
												{CLASSNAME_P_R && CLASSNAME_P_R.length && Object.keys(CLASSNAME_P_R).map((data, index) => {
													return <MenuItem value={CLASSNAME_P_R[data].value}> {CLASSNAME_P_R[data].label}</MenuItem>
												})}
												{!CLASSNAME_P_R.length && (<MenuItem value=" "> No Data</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Margin Top" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.marginTop}
												onChange={handleInputChange}
												name="marginTop">
												{CLASSNAME_M_T && CLASSNAME_M_T.length && Object.keys(CLASSNAME_M_T).map((data, index) => {
													return <MenuItem value={CLASSNAME_M_T[data].value}> {CLASSNAME_M_T[data].label}</MenuItem>
												})}
												{!CLASSNAME_M_T.length && (<MenuItem value=" "> No Data</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Margin Bottom" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.marginBottom}
												onChange={handleInputChange}
												name="marginBottom">
												{CLASSNAME_M_B && CLASSNAME_M_B.length && Object.keys(CLASSNAME_M_B).map((data, index) => {
													return <MenuItem value={CLASSNAME_M_B[data].value}> {CLASSNAME_M_B[data].label}</MenuItem>
												})}
												{!CLASSNAME_M_B.length && (<MenuItem value=" "> No Data</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Margin Left" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.marginLeft}
												onChange={handleInputChange}
												name="marginLeft">
												{CLASSNAME_M_L && CLASSNAME_M_L.length && Object.keys(CLASSNAME_M_L).map((data, index) => {
													return <MenuItem value={CLASSNAME_M_L[data].value}> {CLASSNAME_M_L[data].label}</MenuItem>
												})}
												{!CLASSNAME_M_L.length && (<MenuItem value=" "> No Data</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Margin Right" />
									</div>
									<div className="col-lg-9">
										<FormControl variant="outlined" className={classes.textField}>
											<Select labelId="demo-simple-select-outlined-label" value={inputs.marginRight}
												onChange={handleInputChange}
												name="marginRight">
												{CLASSNAME_M_R && CLASSNAME_M_R.length && Object.keys(CLASSNAME_M_R).map((data, index) => {
													return <MenuItem value={CLASSNAME_M_R[data].value}> {CLASSNAME_M_R[data].label}</MenuItem>
												})}
												{!CLASSNAME_M_R.length && (<MenuItem value=" "> No Data</MenuItem>)}
											</Select>
										</FormControl>
									</div>
								</div>
							</ListItem>
							<ListItem className="mb-15">
								<div className="row inputRow w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Full Section" />
									</div>
									<div className="col-lg-9">
										<FormControlLabel
											className={classes.textField}
											control={<Checkbox checked={inputs.fullSection} onChange={handleCheckboxInputChange} name="fullSection" className="ml-2 mt-1" />}
										/>
									</div>
								</div>
							</ListItem>
						</>}
						<ListItem>
							<button type="button" className="cancelButton" onClick={() => { handleClose() }}>Cancel</button>&nbsp;&nbsp;&nbsp;
							<Button variant="contained" color="primary" className="bannerbutton" type="button" onClick={() => { onSubmit() }}> {catId ? "Update" : "Save"}</Button>

						</ListItem>
					</List>
				</form>
			</div>
		</Fragment>
	);
};

export default CategorySectionForm;
